export const accounts = (state) => state.accounts
export const funderAccounts = (state) => state.funderAccounts
export const selectAllField = (state) => state.selectAllField
export const selectedAccounts = (state) => state.selectedAccounts
export const totalAccounts = (state) => state.totalAccounts
export const totalFunderAccounts = (state) => state.totalFunderAccounts
export const selectedFunderAccount = (state) => state.selectedFunderAccount
export const selectedAuditAccount = (state) => state.selectedAuditAccount
export const selectedIslamicForm = (state) => state.selectedIslamicForm
export const selectAllFunderField = (state) => state.selectAllFunderField
export const viewAccount = (state) => state.viewAccount
